






import {
    Component,
    Vue,
    Inject,
    Prop,
    Watch,
    Model
} from "vue-property-decorator";
import AbpBase from "../lib/abpbase";
import Ajax from "../lib/ajax";
@Component({
    components: {}
})
export default class RegionSelect extends AbpBase {
    @Prop({ type: Number, default: null }) value: number;
    @Prop({ type: String, default: "small" }) size: string;
    regions = [];

    selectedRegions = [];

    onChange(value, selectedData) {
        let label: string = "";
        for (let i = 0; i < selectedData.length; i++) {
            const element = selectedData[i];
            label += element.label;
        }
        this.$emit("on-change", label);
    }

    @Watch("selectedRegions")
    onChangeValue(newVal, oldVal) {
        // this.$emit("input", typeof newVal[2] == 'undefined'? null : newVal[2]);
        this.$emit("input",  newVal[this.selectedRegions.length-1]);
        this.$emit("on-region-change");
    }
    @Watch("value")
    async onValueChanged(newVal, oldVal) {
        if (!newVal) {
            this.selectedRegions = [];
            return;
        }
        if (
            this.selectedRegions.length == 0 || (this.selectedRegions.length==2 && newVal !==this.selectedRegions[1])||
            (this.selectedRegions.length == 3 &&
                newVal !== this.selectedRegions[2])
        ) {
            let reponse = await Ajax.get(
                "/api/services/app/Region/GetCasCadeIdById",
                { params: { id: newVal } }
            );
            var res = reponse.data.result;
            this.selectedRegions = res;
        }
    }
    async created() {
        let reponse = await Ajax.get(
            "/api/services/app/Region/GetCasCadeData",
            {
                params: {}
            }
        );
        this.regions = reponse.data.result;
    }
}
